import PropTypes from 'prop-types';
import React from 'react';

import OrderFormFields from '../../TicketingSettings/components/OrderFormFields';

const EventOrderForm = ({ team, confirm, compact, onFieldsChange, ticketTypes }) => {
  const venueSettingsUrl = `/teams/${team.id}/ticketing_settings`;
  const venueName = confirm.venue?.name || null;
  const settingsLink = (
    <>
      {venueName ? `${venueName}'s ` : "the venue's "}
      <a href={venueSettingsUrl} target="_blank" rel="noopener noreferrer">ticketing settings</a>
    </>
  );

  const header = compact ? (
    <div style={{ marginBottom: 4 }}>
      <div style={{ fontSize: 12, fontWeight: 600, letterSpacing: 0.4, textTransform: 'uppercase', color: 'var(--sl-text-tertiary)' }}>Order form</div>
      <div style={{ fontSize: 12, color: 'var(--sl-text-tertiary)' }}>
        From {settingsLink}. Changes apply to this event.
      </div>
    </div>
  ) : (
    <>
      <h3 style={{ fontSize: 16, fontWeight: 700, margin: 0, color: 'var(--sl-text-primary)' }}>Order Form</h3>
      <p style={{ fontSize: 13, margin: '4px 0 0', color: 'var(--sl-text-tertiary)' }}>
        Fields come from {settingsLink}. Changes here apply to this event only.
      </p>
    </>
  );

  return (
    <OrderFormFields
      team={team}
      event={confirm}
      compact={compact}
      header={header}
      venueName={venueName}
      venueSettingsUrl={venueSettingsUrl}
      onFieldsChange={onFieldsChange}
      ticketTypes={ticketTypes}
    />
  );
};

EventOrderForm.propTypes = {
  team: PropTypes.object.isRequired,
  confirm: PropTypes.object.isRequired,
  compact: PropTypes.bool,
  onFieldsChange: PropTypes.func,
  ticketTypes: PropTypes.arrayOf(PropTypes.object)
};

EventOrderForm.defaultProps = {
  compact: false,
  onFieldsChange: () => {},
  ticketTypes: []
};

export default EventOrderForm;
